import { createAction } from 'redux-actions'
import {
  CLEAR_RESULTS,
  GLOBAL_SEARCH,
  GLOBAL_SEARCH_FAILED,
  GLOBAL_SEARCH_SUCCEEDED,
} from 'Redux/Types/GlobalSearchTypes'

export const clearResults = createAction(CLEAR_RESULTS)
export const globalSearch = createAction(GLOBAL_SEARCH)
export const globalSearchFailed = createAction(GLOBAL_SEARCH_FAILED)
export const globalSearchSucceeded = createAction(GLOBAL_SEARCH_SUCCEEDED)
